import { render, staticRenderFns } from "./FacebookIcon.vue?vue&type=template&id=3d9ab7f2&"
import script from "./FacebookIcon.vue?vue&type=script&lang=ts&"
export * from "./FacebookIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports